import React, { useState } from 'react';
import menu from '../../icons/menu.svg';
import styles from './MenuArea.module.scss';

interface MenuAreaProps {
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const MenuArea: React.FC<MenuAreaProps> = ({ onClick }) => {
  const [isNavVisible, setIsNavVisible] = useState(false);
  const toggleMenu = (e: React.MouseEvent<HTMLDivElement>) => {
    setIsNavVisible(!isNavVisible);
    onClick(e);
  };

  return (
    <div className={styles.menu_area}>
      <div className={styles.menu_icon} onClick={toggleMenu}>
        <img src={menu} />
      </div>
      <nav className={styles.nav}>
        <ul className={styles.menu_list}>
          <li className={styles.menu_item}>
            <a href="#home">ホーム</a>
          </li>
          <li className={styles.menu_item}>
            <a href="#achievements">開発実績</a>
          </li>
          <li className={styles.menu_item}>
            <a href="#about">会社概要</a>
          </li>
          <li className={styles.menu_item}>
            <a href="#blog">ブログ</a>
          </li>
          <li className={styles.menu_item}>
            <a href="#contact">お問い合わせ</a>
          </li>
        </ul>
      </nav>
    </div>
  );
};
